module.exports = __webpack_public_path__ + "static/media/helmet.eeb47db7.png";